import _Divider from "@arco-design/web-react/es/Divider";
import _Spin from "@arco-design/web-react/es/Spin";
import _Popconfirm from "@arco-design/web-react/es/Popconfirm";
import _Button from "@arco-design/web-react/es/Button";
import _Drawer from "@arco-design/web-react/es/Drawer";
import _Message from "@arco-design/web-react/es/Message";
import _useRequest from "@byted/hooks/es/useRequest";
import _Popover from "@arco-design/web-react/es/Popover";
import _Checkbox from "@arco-design/web-react/es/Checkbox";
import _Link from "@arco-design/web-react/es/Link";
import _Typography from "@arco-design/web-react/es/Typography";
import _Input from "@arco-design/web-react/es/Input";
import _Space from "@arco-design/web-react/es/Space";
import _Tag from "@arco-design/web-react/es/Tag";
import _Form from "@arco-design/web-react/es/Form";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useState, useEffect } from 'react';
import { PublishTheme, ValidatePackageName } from '@api/publish';
import { IconArrowRight, IconExclamationCircleFill } from '@arco-design/web-react/icon';
import PublishStatus from './publishProgress';
import style from './style.less';
import { useDispatch, useSelector } from 'react-redux';
import DiffTokens from './diffToken';
import { GetThemeDetail, GetThemeDetailWithUserInfo } from '@src/utils/api/theme';
import { getPkgVersions } from '@src/utils/api/common';
import useLocale from '@src/hooks/useLocale';
import { themeDepLibrary } from '@src/utils/constants';
import usePreviewVersion from '@src/hooks/usePrviewVersion';
import { isExternalProd } from '@src/utils/env';
var getPackagePrefix = function getPackagePrefix(depLibrary) {
  var isVue = depLibrary === themeDepLibrary['vue'];
  return window.projectConfig.npmScope[isVue ? 'vue' : 'react'] || '@arco-design/theme-';
};
var getNextVersion = function getNextVersion(version) {
  var _a = __read(version.split('.'), 3),
    major = _a[0],
    minor = _a[1],
    patch = _a[2];
  return [major, minor, parseInt(patch) + 1].join('.');
};
function VersionInput(_a) {
  var theme = _a.theme;
  var _b = __read(useState(false), 2),
    beta = _b[0],
    setBeta = _b[1];
  var nextVersion = theme.version ? getNextVersion(theme.version) : '0.0.1';
  var _c = useLocale(),
    t = _c.t,
    lang = _c.lang;
  var isZh = lang === 'zh-CN';
  return /*#__PURE__*/React.createElement(_Form.Item, {
    layout: "horizontal",
    label: t['theme.package.version']
  }, !theme.version ? /*#__PURE__*/React.createElement(_Tag, {
    color: "arcoblue"
  }, " ", nextVersion) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Space, {
    size: 6,
    align: "start"
  }, beta ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Tag, {
    color: "arcoblue"
  }, theme.version), /*#__PURE__*/React.createElement(IconArrowRight, {
    style: {
      color: 'var(--color-fill-4)'
    }
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "version",
    initialValue: nextVersion,
    noStyle: {
      showErrorTip: true
    },
    rules: [{
      required: true,
      message: isZh ? '必须填写版本号' : 'version number is required'
    }, {
      validator: function validator(value, cb) {
        if (value && !/^\d+\.\d+\.\d+$/.test(value)) {
          cb(!isZh ? 'The version number is in the wrong format, for example: 1.2.3' : '版本号格式错误，例如: 1.2.3');
        }
      }
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    style: {
      width: 86
    }
  })), /*#__PURE__*/React.createElement(_Typography.Text, {
    type: "secondary",
    style: {
      marginLeft: 6
    }
  }, isZh ? '版本号格式，规范等相关信息可参考' : 'Version number format, specifications and other related information can be referred to', /*#__PURE__*/React.createElement(_Link, {
    href: "https://semver.org/#",
    target: "_blank",
    rel: "noreferrer"
  }, "Semver"))), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "beta",
    layout: "horizontal",
    style: {
      margin: '10px 0 0'
    }
  }, /*#__PURE__*/React.createElement(_Checkbox, {
    style: {
      paddingLeft: 0
    },
    onChange: setBeta
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--color-text-2)',
      fontSize: 12
    }
  }, t['theme.package.beta']), /*#__PURE__*/React.createElement(_Popover, {
    position: 'bottom',
    content: /*#__PURE__*/React.createElement("span", null, t['theme.package.beta.tip1'], /*#__PURE__*/React.createElement("br", null), t['theme.package.beta.tip2'], /*#__PURE__*/React.createElement("br", null), t['theme.package.beta.tip3'])
  }, /*#__PURE__*/React.createElement(IconExclamationCircleFill, {
    style: {
      marginLeft: 4,
      verticalAlign: 'middle',
      color: 'rgb(var(--warning-6))'
    }
  }))))));
}
function DepVersion(_a) {
  var theme = _a.theme,
    onRefresh = _a.onRefresh;
  var _b = __read(useState(theme.depVersion), 2),
    depVersion = _b[0],
    setDepVersion = _b[1];
  var t = useLocale().t;
  useEffect(function () {
    if (!depVersion) {
      getPkgVersions({
        packageName: theme.depLibrary
      }).then(function (res) {
        var _a;
        var tag = (_a = res['dist-tags']) === null || _a === void 0 ? void 0 : _a['latest'];
        setDepVersion(tag);
      });
    }
  }, []);
  return /*#__PURE__*/React.createElement(_Form.Item, {
    layout: "horizontal",
    label: t['theme.package.depVersion']
  }, /*#__PURE__*/React.createElement(_Tag, {
    color: "arcoblue"
  }, depVersion), /*#__PURE__*/React.createElement(_Popover, {
    content: /*#__PURE__*/React.createElement("span", null, "\u53EF\u5728\u4E3B\u9898\u8BBE\u7F6E\u4E2D\u4FEE\u6539\uFF0C", /*#__PURE__*/React.createElement(_Link, {
      target: "_blank",
      hoverable: false,
      href: location.href + '?showThemeEdit=1'
    }, "\u70B9\u51FB\u4FEE\u6539"), /*#__PURE__*/React.createElement("br", null), "\u82E5\u5DF2\u4FEE\u6539\uFF0C\u53EF", /*#__PURE__*/React.createElement(_Link, {
      onClick: onRefresh,
      hoverable: false
    }, "\u70B9\u51FB\u5237\u65B0"))
  }, /*#__PURE__*/React.createElement(IconExclamationCircleFill, {
    style: {
      marginLeft: 4,
      verticalAlign: 'middle'
    }
  })));
}
var ThemePublish = function ThemePublish(props) {
  var _a;
  var _b = useLocale(),
    lang = _b.lang,
    t = _b.t;
  var _c = __read(_Form.useForm(), 1),
    form = _c[0];
  var themeConfig = props.themeConfig;
  var _d = __read(useState(false), 2),
    publishVisible = _d[0],
    setPublishVisible = _d[1];
  var _e = _useRequest(function () {
      return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4, GetThemeDetail({
                themeId: themeConfig.themeId
              })];
            case 1:
              return [2, _a.sent()];
          }
        });
      });
    }),
    loading = _e.loading,
    themeData = _e.data,
    run = _e.run;
  var theme = themeData || themeConfig;
  var _f = _useRequest(function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var params, err_1;
        var _a, _b;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4, form.validate()];
            case 1:
              _c.sent();
              params = form.getFieldsValue();
              _c.label = 2;
            case 2:
              _c.trys.push([2, 4,, 5]);
              return [4, PublishTheme({
                themeId: theme.themeId,
                packageName: theme.packageName || packagePrefix + params.packageName,
                version: params.version || (theme.version ? getNextVersion(theme.version) : '0.0.1'),
                versionLog: params.versionLog,
                beta: params.beta
              })];
            case 3:
              _c.sent();
              setPublishVisible(true);
              return [3, 5];
            case 4:
              err_1 = _c.sent();
              _Message.error({
                content: ((_b = (_a = err_1 === null || err_1 === void 0 ? void 0 : err_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.msg) || t['themePublish.publish.error']
              });
              run();
              return [3, 5];
            case 5:
              return [2];
          }
        });
      });
    }),
    publishing = _f.loading,
    onPublish = _f.run;
  var packagePrefix = getPackagePrefix(theme.depLibrary);
  var isZh = lang === 'zh-CN';
  return /*#__PURE__*/React.createElement(_Drawer, {
    escToExit: !publishVisible,
    width: 869,
    focusLock: false,
    autoFocus: false,
    visible: true,
    title: t['themePublish.title'],
    closable: !publishVisible,
    unmountOnExit: true,
    onCancel: props.onCancel,
    maskClosable: !publishVisible,
    afterOpen: run,
    footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Button, {
      shape: "round",
      disabled: publishing
    }, t['themePublish.cancel']), isExternalProd ? /*#__PURE__*/React.createElement(_Popconfirm, {
      title: "\u6BCF\u4E2A\u4E3B\u9898\u5305\u6BCF\u5C0F\u65F6\u4EC5\u80FD\u53D1\u5E03\u4E00\u6B21",
      onOk: function onOk() {
        onPublish();
      },
      position: "tr"
    }, /*#__PURE__*/React.createElement(_Button, {
      shape: "round",
      type: "primary",
      loading: publishing
    }, t['themePublish.confirm'])) : /*#__PURE__*/React.createElement(_Button, {
      shape: "round",
      type: "primary",
      loading: publishing,
      onClick: onPublish
    }, t['themePublish.confirm'])),
    afterClose: function afterClose() {
      return __awaiter(void 0, void 0, void 0, function () {
        var _data;
        var _a;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4, GetThemeDetailWithUserInfo({
                themeId: theme.themeId
              })];
            case 1:
              _data = _b.sent();
              (_a = props.onFinish) === null || _a === void 0 ? void 0 : _a.call(props, _data);
              return [2];
          }
        });
      });
    }
  }, /*#__PURE__*/React.createElement(_Spin, {
    loading: loading,
    className: style['theme-publish-form'] + " " + (theme.packageName ? '' : style['theme-publish-form-init'])
  }, /*#__PURE__*/React.createElement(_Form, {
    size: "mini",
    form: form,
    layout: "vertical",
    initialValues: __assign(__assign({}, theme), {
      versionLog: '',
      beta: false
    }),
    labelAlign: "left"
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    label: t['themePublish.version.info']
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      border: '1px solid var(--color-border)',
      borderRadius: 2,
      padding: '20px 20px 0 20px'
    }
  }, theme.packageName ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Form.Item, {
    label: t['theme.package.name'],
    layout: "horizontal"
  }, /*#__PURE__*/React.createElement(_Typography.Text, null, theme.packageName))) : /*#__PURE__*/React.createElement(_Form.Item, {
    layout: "horizontal",
    label: t['theme.package.name'],
    field: "packageName",
    requiredSymbol: false,
    validateTrigger: ['onBlur'],
    wrapperCol: {
      style: {
        maxWidth: 500
      }
    },
    rules: [{
      validator: function validator(value, cb) {
        return __awaiter(this, void 0, void 0, function () {
          var regExp, data;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                if (!value) {
                  return [2, cb(isZh ? '必须填写主题包名' : 'Package name is required')];
                } else if (value.length < 4) {
                  return [2, cb(isZh ? '至少填写四个字符' : 'Fill in at least four characters')];
                } else {
                  regExp = new RegExp("^" + packagePrefix + "[a-z0-9][-a-z0-9]*[a-z0-9]$");
                  if (!regExp.test("" + packagePrefix + value)) {
                    return [2, cb(isZh ? '包名必须以 ' + packagePrefix + ' 为前缀，只能包含字母，数字和 "-"，且首尾不能为 "-" ' : "The package name must be prefixed with '" + packagePrefix + "', can only contain letters, numbers and \"-\", and cannot start and end with \"-\" '")];
                  }
                }
                return [4, ValidatePackageName({
                  packageName: "" + packagePrefix + value,
                  isVue: theme.depLibrary === themeDepLibrary.vue
                })];
              case 1:
                data = _a.sent();
                cb(data.message);
                return [2];
            }
          });
        });
      }
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    addBefore: packagePrefix
  })), /*#__PURE__*/React.createElement(_Space, {
    size: 0,
    direction: theme.packageName ? 'vertical' : 'horizontal'
  }, /*#__PURE__*/React.createElement(VersionInput, {
    theme: theme
  }), !theme.packageName && /*#__PURE__*/React.createElement(_Divider, {
    type: "vertical",
    style: {
      margin: '0 36px 20px'
    }
  }), /*#__PURE__*/React.createElement(DepVersion, {
    theme: theme,
    onRefresh: run
  })))), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "versionLog",
    label: t['themePublish.version.desc'],
    requiredSymbol: false,
    extra: isZh ? '填写的描述将会展示为发版日志' : 'The filled description will be displayed as a release log',
    rules: [{
      required: true,
      message: isZh ? '必须填写版本描述' : 'Description is required'
    }]
  }, /*#__PURE__*/React.createElement(_Input.TextArea, {
    style: {
      width: 502
    },
    rows: 4
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    label: t['themePublish.version.detail']
  }, /*#__PURE__*/React.createElement(DiffTokens, {
    rowSelections: false,
    themeId: theme.themeId,
    refresh: ((_a = theme.publishStatus) === null || _a === void 0 ? void 0 : _a.status) === "success",
    onLoad: function onLoad(keys) {
      form.setFieldValue('versionLog', "Release: \n" + keys.map(function (item) {
        return "- " + item + ": ";
      }).join('\n'));
    }
  })))), /*#__PURE__*/React.createElement(PublishStatus, {
    themeId: theme.themeId,
    visible: publishVisible,
    onFinish: function onFinish() {
      run();
      setPublishVisible(false);
    }
  }));
};
export default function Publish(props) {
  var _a = __read(useState(false), 2),
    themePublishVisible = _a[0],
    setThemePublishVisible = _a[1];
  var dispatch = useDispatch();
  var themeConfig = useSelector(function (state) {
    return state.theme.themeConfig;
  });
  var _b = usePreviewVersion(),
    isPreview = _b.isPreview,
    previewMsg = _b.previewMsg;
  if (!themeConfig.isMine) {
    return /*#__PURE__*/React.createElement("span", null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      if (isPreview) {
        _Message.warning(previewMsg);
        return;
      }
      setThemePublishVisible(true);
    }
  }, props.children), themePublishVisible && /*#__PURE__*/React.createElement(ThemePublish, {
    themeConfig: themeConfig,
    visible: themePublishVisible,
    onFinish: function onFinish(newTheme) {
      if (newTheme) {
        dispatch({
          type: 'updateThemeConfig',
          payload: newTheme
        });
      }
      setThemePublishVisible(false);
    },
    onCancel: function onCancel() {
      setThemePublishVisible(false);
    }
  }));
}